import React from 'react';
import { Box, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { useTranslation } from 'react-i18next';

const StepSelectDates = ({
  arrivalDate,
  departureDate,
  setDepartureDate,
  availabilityData,
  availabilityError,
  dateToInputFormat,
}) => {
  const { t } = useTranslation();
  const validDepartureDates = availabilityData.map(item => item.departureDate);

  const isDateValid = (date) => {
    if (!date) return false;
    const dateStr = dateToInputFormat(date);
    return validDepartureDates.includes(dateStr);
  };

  const handleDepartureChange = (newDate) => {
    setDepartureDate(newDate);
  };

  return (
    <Box sx={{ py: 3 }}>
      <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500 }}>
        {t('varausModal.stepSelectDates.select')}
      </Typography>

      {availabilityError && (
        <Typography variant="body2" color="error" sx={{ mb: 2 }}>
          {availabilityError.message || 'Failed to load availability'}
        </Typography>
      )}

      <DatePicker
        sx={{ mb: 2 }}
        label={t('varausModal.stepSelectDates.arrival')}
        value={arrivalDate}
        disabled
        slotProps={{
          textField: {
            fullWidth: true,
            variant: 'outlined',
          },
        }}
      />
      <DatePicker
        label={t('varausModal.stepSelectDates.departure')}
        value={departureDate}
        onChange={handleDepartureChange}
        shouldDisableDate={date => !isDateValid(date)}
        defaultValue={arrivalDate}
        slotProps={{
          textField: {
            fullWidth: true,
            variant: 'outlined',
          },
        }}
      />
    </Box>
  );
};

export default StepSelectDates;
